import React from 'react';
import { Select } from './common';

export const RevenueFilters = ({
  revStart, setRevStart,
  revEnd, setRevEnd,
  revStatus, setRevStatus,
  revCurrency, setRevCurrency,
  revEmail, setRevEmail,
  revPlan, setRevPlan,
  onApply,
}) => (
  <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
    <div>
      <label className="text-xs text-[var(--isp-body)]">Start date</label>
      <input
        type="date"
        value={revStart}
        onChange={(e) => setRevStart(e.target.value)}
        className="mt-1 w-full rounded-xl bg-slate-950/40 border border-[var(--isp-glass-border)] px-3 py-2 text-sm text-[var(--isp-body)] outline-none"
      />
    </div>
    <div>
      <label className="text-xs text-[var(--isp-body)]">End date</label>
      <input
        type="date"
        value={revEnd}
        onChange={(e) => setRevEnd(e.target.value)}
        className="mt-1 w-full rounded-xl bg-slate-950/40 border border-[var(--isp-glass-border)] px-3 py-2 text-sm text-[var(--isp-body)] outline-none"
      />
    </div>
    <Select
      label="Payment status"
      value={revStatus}
      onChange={setRevStatus}
      options={[
        { value: 'all', label: 'All' },
        { value: 'completed', label: 'Completed' },
        { value: 'failed', label: 'Failed' },
        { value: 'refunded', label: 'Refunded' },
        { value: 'refund_failed', label: 'Refund failed' },
      ]}
    />
    <Select
      label="Currency"
      value={revCurrency}
      onChange={setRevCurrency}
      options={[
        { value: 'all', label: 'All' },
        { value: 'GHS', label: 'GHS' },
        { value: 'USD', label: 'USD' },
      ]}
    />
    <div className="lg:col-span-2">
      <label className="text-xs text-[var(--isp-body)]">Email search</label>
      <input
        value={revEmail}
        onChange={(e) => setRevEmail(e.target.value)}
        placeholder="customer@email.com"
        className="mt-1 w-full rounded-xl bg-slate-950/40 border border-[var(--isp-glass-border)] px-3 py-2 text-sm text-[var(--isp-body)] outline-none"
      />
    </div>
    <div>
      <label className="text-xs text-[var(--isp-body)]">Plan ID</label>
      <input
        value={revPlan === 'all' ? '' : revPlan}
        onChange={(e) => setRevPlan(e.target.value ? e.target.value : 'all')}
        placeholder="optional"
        className="mt-1 w-full rounded-xl bg-slate-950/40 border border-[var(--isp-glass-border)] px-3 py-2 text-sm text-[var(--isp-body)] outline-none"
      />
    </div>
    <div className="flex items-end gap-2">
      <button
        type="button"
        onClick={onApply}
        className="w-full inline-flex items-center justify-center rounded-xl bg-white/10 hover:bg-white/15 text-[var(--isp-heading)] font-semibold px-4 py-2.5 border border-[var(--isp-glass-border)]"
        data-testid="admin-revenue-apply"
      >
        Apply
      </button>
    </div>
  </div>
);

export const AuditFilters = ({ auditAction, setAuditAction, auditEmail, setAuditEmail, onApply }) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
    <div>
      <label className="text-xs text-[var(--isp-body)]">Action filter</label>
      <input
        value={auditAction}
        onChange={(e) => setAuditAction(e.target.value)}
        placeholder="e.g. export, view"
        className="mt-1 w-full rounded-xl bg-slate-950/40 border border-[var(--isp-glass-border)] px-3 py-2 text-sm text-[var(--isp-body)] outline-none"
      />
    </div>
    <div>
      <label className="text-xs text-[var(--isp-body)]">Admin email</label>
      <input
        value={auditEmail}
        onChange={(e) => setAuditEmail(e.target.value)}
        placeholder="admin@email.com"
        className="mt-1 w-full rounded-xl bg-slate-950/40 border border-[var(--isp-glass-border)] px-3 py-2 text-sm text-[var(--isp-body)] outline-none"
      />
    </div>
    <div className="flex items-end">
      <button
        type="button"
        onClick={onApply}
        className="w-full inline-flex items-center justify-center rounded-xl bg-white/10 hover:bg-white/15 text-[var(--isp-heading)] font-semibold px-4 py-2.5 border border-[var(--isp-glass-border)]"
        data-testid="admin-audit-apply"
      >
        Apply
      </button>
    </div>
  </div>
);
